<script>
import axios from 'axios'
import applicationConstants from '@/constants/ApplicationConstants'
import { BehaviorSubject } from 'rxjs'
import xmlUtils from '@/utils/XmlUtils.vue'

const authUserSubject = new BehaviorSubject(localStorage.getItem('user-auth'))

export default {
  name: 'AuthenticationService',
  authUser: authUserSubject.asObservable(),
  get authUserValue () {
    return authUserSubject.value
  },
  methods: {
    login (userCredentials) {
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion
      })
      return axios
        .post(
          applicationConstants.publicServerBaseUrl + 'GetUserProfile',
          data,
          {
            crossdomain: true,
            headers: {
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              common: {
                Authorization: `Basic ${btoa(
                  userCredentials.username + ':' + userCredentials.password
                )}`
              }
            }
          }
        )
        .then((res, rej) => {
          const response = xmlUtils.methods.getParseObjectFromXml(res.data)
          if (+response.GetUserProfileResponse.ErrorCode._text !== 1) {
            if (+response.GetUserProfileResponse.ErrorCode._text === 4) {
              if (!localStorage.getItem('invalid-login-count')) {
                localStorage.setItem('invalid-login-count', 1)
              } else {
                localStorage.setItem('invalid-login-count', (+localStorage.getItem('invalid-login-count')) + 1)
              }
            }
            return new Promise((resolve, reject) =>
              reject(
                new Error(
                  response.GetUserProfileResponse.ErrorDescription._text
                )
              )
            )
          } else {
            const auth = res.config.headers.Authorization

            localStorage.setItem('user-auth', auth)
            if (!response.GetUserProfileResponse.FirstName._text && !response.GetUserProfileResponse.LastName._text) {
              response.GetUserProfileResponse.DateOfBirth._text = '01/01/1970'
            }
            localStorage.setItem('user-info', JSON.stringify(response.GetUserProfileResponse))
            localStorage.removeItem('recipient')
            localStorage.removeItem('select-recipient')
            localStorage.removeItem('funding-method')
            authUserSubject.next(auth)
            return new Promise(resolve => resolve(response))
          }
        })
    },
    logout () {
      authUserSubject.next(null)
      localStorage.removeItem('emmunition_user_id')
      localStorage.removeItem('user-auth')
      localStorage.removeItem('user-info')
      localStorage.removeItem('debugger')
      localStorage.removeItem('select-recipient')
      localStorage.removeItem('new-recipient')
      localStorage.removeItem('has-transactions')
      localStorage.removeItem('recipient')
      localStorage.removeItem('funding-method')
      localStorage.removeItem('active-item')
      localStorage.removeItem('afterdm')
    },
    signup (registration) {
      registration.MobileNumber = `+1${registration.MobileNumber}`
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion,
        ...registration
      })
      return axios
        .post(
          applicationConstants.publicServerBaseUrl + 'SignupUser',
          data,
          {
            crossdomain: true,
            headers: {
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            }
          }
        )
        .then((res, rej) => {
          const response = xmlUtils.methods.getParseObjectFromXml(res.data)
          if (+response.SignupUserResponse.ErrorCode._text !== 1) {
            return new Promise((resolve, reject) =>
              reject(
                new Error(
                  response.SignupUserResponse.ErrorDescription._text
                )
              )
            )
          } else {
            return new Promise(resolve => resolve(response))
          }
        })
    },
    resetPassword (UserEmailAddress, UserPhoneNumber) {
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion,
        UserEmailAddress,
        UserPhoneNumber
      })
      return axios
        .post(
          applicationConstants.publicServerBaseUrl + 'ResetLostPassword',
          data,
          {
            crossdomain: true,
            headers: {
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'
            }
          }
        )
        .then((res, rej) => {
          const response = xmlUtils.methods.getParseObjectFromXml(res.data)
          if (+response.ResetLostPasswordResponse.ErrorCode._text !== 1) {
            return new Promise((resolve, reject) =>
              reject(
                new Error(
                  response.ResetLostPasswordResponse.ErrorDescription._text
                )
              )
            )
          } else {
            return new Promise(resolve => resolve(response))
          }
        })
    },
    InitiatePhoneVerificationByMobileNumber (mobileNumber) {
      let modifiedNum = mobileNumber.replace(/[^0-9]/g, '')
      const data = JSON.stringify({
        ClientAppId: applicationConstants.logInBodyRequest.ClientAppId,
        ClientAppVersion: applicationConstants.logInBodyRequest.ClientAppVersion,
        CellPhoneNo: modifiedNum
      })
      return axios.post(
        applicationConstants.publicServerBaseUrl + 'InitiatePhoneVerificationByMobileNumber',
        data,
        {
          crossdomain: true,
          headers: {
            'Accept': '*/*',
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
          }
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/AuthenticationService.vue